(() => {
  const initialise = scope => {
    const feeds = scope.matches?.('[data-pd3-products]') ? [scope] : scope.querySelectorAll('[data-pd3-products]');
    feeds.forEach(feed => {
      if (feed.dataset.ready === 'true') return;
      const tablist = feed.querySelector('[data-pd3-tablist]');
      const tabs = [...feed.querySelectorAll('[data-pd3-tab]')];
      const panels = [...feed.querySelectorAll('[data-pd3-panel]')];
      if (!tablist || tabs.length !== panels.length || !tabs.length) return;
      const mobile = window.matchMedia('(max-width: 700px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let selectedTab = 0;
      let resizeFrame = 0;
      let viewportWidth = window.innerWidth;

      const rows = panels.map(panel => {
        const track = panel.querySelector('[data-pd3-product-row]');
        if (!track) return null;
        return {
          panel,
          track,
          cards: [...track.querySelectorAll('.pd3-products__card')],
          controls: panel.querySelector('[data-pd3-row-controls]'),
          previous: panel.querySelector('[data-pd3-row-prev]'),
          next: panel.querySelector('[data-pd3-row-next]'),
          position: panel.querySelector('[data-pd3-row-position]'),
          index: 0,
          frame: 0
        };
      });

      function renderPosition(row) {
        if (row.previous) row.previous.disabled = row.index === 0;
        if (row.next) row.next.disabled = row.index >= row.cards.length - 1;
        if (row.position) {
          const text = row.position.dataset.positionTemplate.replace('__current__', String(row.index + 1)).replace('__total__', String(row.cards.length));
          if (row.position.textContent !== text) row.position.textContent = text;
        }
      }

      function syncPosition(row) {
        row.frame = 0;
        if (row.panel.hidden || !mobile.matches || !row.cards.length) return;
        const edge = row.track.getBoundingClientRect().left + row.track.clientLeft;
        let nearest = 0;
        let distance = Infinity;
        row.cards.forEach((card, index) => {
          const difference = Math.abs(card.getBoundingClientRect().left - edge);
          if (difference < distance) {
            nearest = index;
            distance = difference;
          }
        });
        row.index = nearest;
        renderPosition(row);
      }

      function scrollToCard(row, index, instant = false) {
        if (!row || !row.cards.length || !mobile.matches) return;
        index = Math.max(0, Math.min(index, row.cards.length - 1));
        const left = row.track.scrollLeft + row.cards[index].getBoundingClientRect().left - row.track.getBoundingClientRect().left - row.track.clientLeft;
        row.track.scrollTo({ left, behavior: instant || reducedMotion.matches ? 'auto' : 'smooth' });
        if (instant || reducedMotion.matches) {
          row.index = index;
          renderPosition(row);
        }
      }

      rows.forEach(row => {
        if (!row) return;
        row.previous?.addEventListener('click', () => scrollToCard(row, row.index - 1));
        row.next?.addEventListener('click', () => scrollToCard(row, row.index + 1));
        row.track.addEventListener('scroll', () => {
          if (!row.frame) row.frame = requestAnimationFrame(() => syncPosition(row));
        }, { passive: true });
        row.track.addEventListener('scrollend', () => syncPosition(row));
        row.panel.addEventListener('keydown', event => {
          if (event.target !== row.panel || !mobile.matches) return;
          let target;
          if (event.key === 'ArrowRight') target = row.index + 1;
          else if (event.key === 'ArrowLeft') target = row.index - 1;
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = row.cards.length - 1;
          else return;
          event.preventDefault();
          scrollToCard(row, target);
        });
      });

      tablist.setAttribute('role', 'tablist');
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[index].id);
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('tabindex', '0');
      });
      const activate = (index, focus = false) => {
        selectedTab = index;
        tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.setAttribute('tabindex', selected ? '0' : '-1');
          panels[tabIndex].hidden = !selected;
        });
        const row = rows[index];
        if (row) {
          row.track.scrollTo({ left: 0, behavior: 'auto' });
          row.index = 0;
          renderPosition(row);
        }
        if (focus) tabs[index].focus({ preventScroll: true });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', event => {
          event.preventDefault();
          activate(index);
        });
        tab.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = tabs.length - 1;
          else if (event.key === ' ') target = index;
          else return;
          event.preventDefault();
          activate(target, true);
        });
      });

      function configure() {
        rows.forEach(row => {
          if (!row) return;
          if (row.controls) row.controls.hidden = !mobile.matches || row.cards.length < 2;
          if (!mobile.matches) row.track.scrollTo({ left: 0, behavior: 'auto' });
        });
        const row = rows[selectedTab];
        if (row && mobile.matches) scrollToCard(row, row.index, true);
      }
      function resized() {
        if (viewportWidth === window.innerWidth) return;
        viewportWidth = window.innerWidth;
        cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(configure);
      }
      function unload(event) {
        if (event.target !== feed && !event.target.contains(feed)) return;
        mobile.removeEventListener('change', configure);
        window.removeEventListener('resize', resized);
        cancelAnimationFrame(resizeFrame);
        rows.forEach(row => { if (row) cancelAnimationFrame(row.frame); });
        document.removeEventListener('shopify:section:unload', unload);
      }
      mobile.addEventListener('change', configure);
      window.addEventListener('resize', resized, { passive: true });
      document.addEventListener('shopify:section:unload', unload);
      activate(0);
      configure();
      feed.dataset.ready = 'true';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  else initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
